import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Дух Приморья</h3>
          <p>Вкус дикой тайги в твоем бокале</p>
        </div>
        
        <div className="footer-section">
          <h4>Реквизиты</h4>
          <p>ИП Бурков Максим Артурович</p>
          <p>ОГРНИП: 325253600073026</p>
          <p>ИНН: 250822172828</p>
          <p>Адрес: Приморский край, г. Находка</p>
        </div>
        
        <div className="footer-section">
          <h4>Контакты</h4>
          <p>
            <FaPhone /> <a href="tel:+79915376731" className="footer-link">+7 (991) 537-67-31</a> Мск
          </p>
          <p>
            <FaPhone /> <a href="tel:+79940081324" className="footer-link">+7 (994) 008-13-24</a> Дальний Восток
          </p>
          <p>
            <FaEnvelope /> <a href="mailto:duh_primorye@mail.ru" className="footer-link">duh_primorye@mail.ru</a>
          </p>
        </div>
        
        <div className="footer-section">
          <h4>Информация</h4>
          <p><Link to="/terms" className="footer-link">Пользовательское соглашение</Link></p>
          <p><Link to="/privacy-policy" className="footer-link">Политика конфиденциальности</Link></p>
          <div className="payment-logos">
            <img src="/HorizontalLogos.png" alt="Платежные системы" className="payment-systems" />
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2026 Дух Приморья. Все права защищены.</p>
      </div>
    </footer>
  );
}

export default Footer;
